import React, { useId } from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  id,
  ...props
}: TextareaProps) {
  const inputId = id || useId();
  return <div className="w-full" data-id="element-202">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-black mb-2" data-id="element-203">
          {label}
        </label>}
      <textarea id={inputId} className={`
          flex min-h-[120px] w-full rounded-none border border-neutral-200 bg-white px-4 py-3 text-base placeholder:text-neutral-400 
          focus:outline-none focus:border-black focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50
          resize-y transition-colors duration-200
          ${error ? 'border-red-500 focus:border-red-500' : ''}
          ${className}
        `} {...props} data-id="element-204" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-205">{error}</p>}
    </div>;
}